import React, {useState} from 'react';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import Property from '@episerver/spa-core/Components/Property';
import ProviderManager from '../../../provider/providerManager';
import TextInput from '../../Shared/TextInput/TextInput';
import PopUp from '../../Shared/Popup/PopUp';
import BtnPinkSmall from '../../Shared/Buttons/BtnPinkSmall';
import images from './images/images';
import Image from 'app/Components/Shared/Image/image';
const UnsubscribeMail = (props) => {
  const [emailAddress, setEmailAddress] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [error, setError] = useState('');
  const [showPopUpSuccess, setShowPopUpSuccess] = useState(false);
  const [showPopUpFailed, setShowPopUpFailed] = useState(false);
  const isEmail = !props.iContent.unsubscribeType.value || props.iContent.unsubscribeType.value == 0 ? true : false;

  const closePopUp = () => {
    setShowPopUpSuccess(false);
    setShowPopUpFailed(false);
  };

  function Unsubscribe() {
    if (isEmail) {
      UnsubscribeMail();
    } else {
      UnsubscribeSms();
    }
  }

  async function UnsubscribeMail() {
    if (error == '' && emailAddress != '') {
      try {
        let result = await ProviderManager.getProviderData('UnsubscribeMail', [emailAddress]);
        if (result.Body.isSuccess) {
          setShowPopUpSuccess(true);
        } else {
          setShowPopUpFailed(true);
        }
        return result;
      } catch (error) {
        setShowPopUpFailed(true);
      }
    } else {
      if (error == '') setError('נא להזין כתובת מייל');
    }
  }

  async function UnsubscribeSms() {
    if (error == '' && phoneNumber != '') {
      try {
        let result = await ProviderManager.getProviderData('UnsubscribeSms', [phoneNumber]);
        if (result.Body.isSuccess) {
          setShowPopUpSuccess(true);
        } else {
          setShowPopUpFailed(true);
        }
        return result;
      } catch (error) {
        setShowPopUpFailed(true);
      }
    } else {
      if (error == '') setError('אנא הכנס ערך תקין');
    }
  }

  function setEmail(email) {
    setEmailAddress(email);
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      setError('');
    } else {
      setError('נא להזין כתובת מייל תקינה');
    }
  }

  function setPhone(phoneNumber) {
    const cleanPhoneNumber = phoneNumber.replace(/\D/g, ''); // Remove non-numeric characters
    setPhoneNumber(cleanPhoneNumber);
    if (/^05\d{8}$/.test(cleanPhoneNumber)) {
      setError('');
    } else {
      setError('אנא הכנס ערך תקין');
    }
  }

  return (
    <div className='unsubscribe-mail'>
      <div className='tabs-container'>
        <div className='title'>{props.iContent.title.value}</div>
        <div className='blueBorder'>
          <Property context={props.context} iContent={props.iContent} field='content' />
        </div>
        {isEmail ? (
          <>
            <div className='title-container'>דוא"ל להסרה</div>
            <TextInput
              className='email'
              name='email'
              type='email'
              id='email'
              placeholder='כתובת מייל'
              value={emailAddress}
              error={error}
              onChange={(e) => setEmail(e.currentTarget.value)}
            />
          </>
        ) : (
          <>
            <div className='title-container'>מספר טלפון להסרה</div>
            <TextInput
              className='phoneNumber'
              name='phoneNumber'
              type='tel'
              maxLength='10'
              id='phoneNumber'
              placeholder='מספר טלפון'
              value={phoneNumber}
              error={error}
              onChange={(e) => setPhone(e.currentTarget.value)}
            />
          </>
        )}
        <div className='btn-wrapper'>
          <BtnSubmit text={'הסר מרשימת התפוצה'} onclick={() => Unsubscribe()} />
        </div>

        <PopUp showPopUp={showPopUpSuccess} onClose={closePopUp} className={'container-popup'}>
          <div className='popup-unsubscribe-wrapper'>
            <div className='sub-title'>
              הבקשה עבור: {isEmail ? emailAddress : phoneNumber}
              <br></br>נקלטה
            </div>

            <div>
              <Image className='icon-img' alt='icon' src={images.done}/>
            </div>
            <div className='sub-title'>
              {' '}
              תהליך ההסרה מרשימת התפוצה לדברי דואר פרסומיים מ{window.Config.brand_Name_HE}{' '}
              {isEmail ? 'לכתובת זו יושלם ככל שהכתובת קיימת' : 'למספר זה יושלם ככל שהמספר קיים'}
            </div>
            <div className='btn-wrapper'>
              <BtnPinkSmall
                text='סגור'
                onclick={() => {
                  closePopUp();
                }}
              />
            </div>
          </div>
        </PopUp>
        <PopUp showPopUp={showPopUpFailed} onClose={closePopUp} className={'container-popup'}>
          <div className='popup-unsubscribe-wrapper'>
            <div className='sub-title'>
              הבקשה עבור: {isEmail ? emailAddress : phoneNumber}
              <br></br>נכשלה
            </div>
            <div className='sub-title'>אנא נסה שוב במועד מאוחר יותר</div>
            <div className='btn-wrapper'>
              <BtnPinkSmall
                text='סגור'
                onclick={() => {
                  closePopUp();
                }}
              />
            </div>
          </div>
        </PopUp>
      </div>
    </div>
  );
};
export default UnsubscribeMail;
